import DeploymentViewer from "./deployment-viewer"
export default function Deployment() {
  return <DeploymentViewer />
}
